import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { NotificationsProvider } from "ui/context/NotificationsContext";
import { LivestreamContextProvider } from "ui/context/LivestreamContext";
import { SessionContextProvider } from "ui/context/SessionContext";
import { PublishContextProvider } from "ui/context/PublishContext";
import { TaskContextProvider } from "ui/context/TaskContext";

type Props = {
    children: React.ReactNode;
};

const AppContainer: React.FC<Props> = ({ children }) => {
    const queryClient = new QueryClient();
    return (
        <Router>
            <QueryClientProvider client={queryClient}>
                <SessionContextProvider>
                    <LivestreamContextProvider>
                        <PublishContextProvider>
                            <NotificationsProvider>
                                <TaskContextProvider>
                                    {children}
                                </TaskContextProvider>
                            </NotificationsProvider>
                        </PublishContextProvider>
                    </LivestreamContextProvider>
                </SessionContextProvider>
            </QueryClientProvider>
        </Router>
    );
};

export default AppContainer;
